module.exports = __webpack_public_path__ + "static/Customize-Colours-4-e1403553691297-f409f94bb503b6c9345d933977e1609d.jpg";